import { Box, Divider, Typography } from "@mui/material"
import { KeyboardEventHandler, ReactElement } from "react"
import { Control } from "react-hook-form"

import { invalidNumberMessage } from "./assessHPDeviceForm"
import ValidatedAutocomplete from "../../components/inputs/validated/validatedSelect"
import ValidatedTextField from "../../components/inputs/validated/validatedTextField"
import {
    HP_IN_ACCORDANCE_11_STATUSES,
    HP_IN_ACCORDANCE_12_STATUSES,
} from "../../constants/lct/evdc/assessDeviceForm"
import { POSITIVE_NUMBER_REGEX } from "../../constants/patterns"

type SubDeviceAssessmentFormHPProps = {
    control: Control
    title: string
    subtitle: string
    registerNames: string[]
    handleKeyPress: KeyboardEventHandler<HTMLDivElement>
}

const SubDeviceAssessmentFormHP = ({
    control,
    title,
    subtitle,
    registerNames,
    handleKeyPress,
}: SubDeviceAssessmentFormHPProps): ReactElement => (
    <>
        <Box>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body1" color="text.secondary">
                {subtitle}
            </Typography>
        </Box>
        <ValidatedAutocomplete
            control={control}
            required
            registerName={registerNames[0]}
            label="In accordance with EN 61000-3-12"
            options={Object.keys(HP_IN_ACCORDANCE_12_STATUSES)}
            getOptionLabel={(option) =>
                HP_IN_ACCORDANCE_12_STATUSES[
                    option as keyof typeof HP_IN_ACCORDANCE_12_STATUSES
                ] ?? ""
            }
        />
        <ValidatedTextField
            control={control}
            required={false}
            registerName={registerNames[1]}
            placeholder="SSC Minimum 3 Phase"
            label="SSC Minimum 3 Phase"
            multiline
            handleKeyPress={handleKeyPress}
            customRules={{
                pattern: {
                    value: POSITIVE_NUMBER_REGEX,
                    message: invalidNumberMessage,
                },
            }}
            optional
        />
        <ValidatedAutocomplete
            control={control}
            required
            registerName={registerNames[2]}
            label="In accordance with EN 61000-3-11"
            options={Object.keys(HP_IN_ACCORDANCE_11_STATUSES)}
            getOptionLabel={(option) =>
                HP_IN_ACCORDANCE_11_STATUSES[
                    option as keyof typeof HP_IN_ACCORDANCE_11_STATUSES
                ] ?? ""
            }
        />
        <ValidatedTextField
            control={control}
            required={false}
            registerName={registerNames[3]}
            placeholder="Zmax (Ω)"
            label="Zmax (Ω)"
            multiline
            handleKeyPress={handleKeyPress}
            customRules={{
                pattern: {
                    value: POSITIVE_NUMBER_REGEX,
                    message: invalidNumberMessage,
                },
            }}
            optional
        />
        <Divider />
    </>
)

export default SubDeviceAssessmentFormHP
